import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  id: null,
  name: '',
  name_de: '',
  name_fr: '',
  description: '',
  description_de: '',
  description_fr: '',
  slug: '',
  slug_de: '',
  slug_fr: '',
  is_active: true,
  sort_order: 0,
  blogs_count: 0,
  seo: {
    title: '',
    title_de: '',
    title_fr: '',
    description: '',
    description_de: '',
    description_fr: '',
  },
  ...item,
})

export const state = () => ({
  items: [],
  item: null,
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {
  list(state) {
    return state.items
  },
}

export const actions = {
  fetchBlogCategories({ commit }, params = {}) {
    return this.$axios.$get('admin/blog-categories', { params }).then((response) => {
      commit('load', response.data || [])
    })
  },

  fetchBlogCategory({ commit }, id) {
    return this.$axios.$get(`admin/blog-categories/${id}`).then((response) => {
      commit('set', response.data)
      // Return a deep copy to prevent Vuex state mutation
      return JSON.parse(JSON.stringify(response.data))
    })
  },

  createBlogCategory({ commit }, data) {
    return this.$axios.$post('admin/blog-categories/create', data).then((response) => {
      commit('add', defaultItem(response.data))
      return response
    })
  },

  updateBlogCategory({ commit }, data) {
    return this.$axios.$put(`admin/blog-categories/${data.id}`, data).then((response) => {
      commit('update', response.data)
      return response
    })
  },

  removeBlogCategory({ commit }, item) {
    return this.$axios.$delete(`admin/blog-categories/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
      return response
    })
  },
}
